import React from "react";

type FormButtonProps = {
  label: string;
};

export default function FormButton({ label }: FormButtonProps) {
  return (
    <div className="col-span-2">
      <button
        type="submit"
        className="w-full bg-primary text-white py-2 px-4 rounded shadow hover:bg-primary-dark transition"
      >
        {label}
      </button>
    </div>
  );
}
